import axios from "axios";

export const attachResponseInterceptor = (apiInstance) => {
    apiInstance.interceptors.response.use(
        (response) => response,
        async (error) => {
            if (error.response?.status === 401) {
                try {
                    const refreshResponse = await axios.post("/refresh-token", {
                        token: localStorage.getItem("refreshToken"),
                    });

                    const newToken = refreshResponse?.data?.newToken;
                    if (newToken) {
                        localStorage.setItem("accessToken", newToken);
                        error.config.headers = error.config.headers || {};
                        error.config.headers.Authorization = `Bearer ${newToken}`;
                        return axios(error.config);
                    }
                } catch (refreshError) {
                    localStorage.removeItem("accessToken");
                    window.location.href = "/login";
                    return Promise.reject(refreshError);
                }
            }

            return Promise.reject(error);
        }
    );
};

